import {
  COACHING_ASTRO_DISCLAIMER,
  VEDIC_CHART_SECTIONS,
  VEDIC_GLOSSARY,
  VEDIC_INTRO,
  VEDIC_POINTS,
} from '@mlm/shared/coaching';
import { Eyebrow, Screen } from '../components/primitives';

/**
 * What the words in a reading mean. The chart and the daily guidance print
 * Mahadasha, nakshatra and pada without ever saying what they are, so this is
 * the screen both of them link to.
 *
 * Pure copy from `@mlm/shared/coaching/glossary`: no request, no birth details
 * and nothing to load, so it reads the same before a member has a chart.
 */
export function AlignLearnPage() {
  return (
    <Screen back="/align" eyebrow="Learn" title="The words in your reading" subtitle={VEDIC_INTRO}>
      <section className="border-b border-border px-5 py-6">
        <Eyebrow className="mb-5">What it is</Eyebrow>
        <div className="space-y-6">
          {VEDIC_POINTS.map((point) => (
            <div key={point.title}>
              <h2 className="font-display text-[1.1rem] font-semibold leading-snug text-ink">
                {point.title}
              </h2>
              <p className="mt-1.5 text-sm leading-relaxed text-ink/70">{point.body}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="border-b border-border px-5 py-6">
        <Eyebrow className="mb-5">Reading your own screens</Eyebrow>
        <dl className="space-y-5">
          {VEDIC_CHART_SECTIONS.map((section) => (
            <div key={section.label}>
              <dt className="eyebrow">{section.label}</dt>
              <dd className="mt-1.5 text-sm leading-relaxed text-ink/70">{section.body}</dd>
            </div>
          ))}
        </dl>
      </section>

      <section className="border-b border-border px-5 py-6">
        <Eyebrow className="mb-5">Glossary</Eyebrow>
        <dl>
          {VEDIC_GLOSSARY.map((entry) => (
            <div key={entry.term} className="border-b border-border py-4 first:pt-0 last:border-0">
              <dt className="eyebrow">{entry.term}</dt>
              <dd className="mt-1.5 text-sm leading-relaxed text-ink/70">{entry.definition}</dd>
            </div>
          ))}
        </dl>
      </section>

      <p className="px-5 py-6 text-xs leading-relaxed text-muted-foreground">
        {COACHING_ASTRO_DISCLAIMER}
      </p>
    </Screen>
  );
}
